"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchCommand = void 0;
class SearchCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { value, currency, contents, content_type, search_string } = this.input;
        const { fbq: facebookQueue } = config;
        const object = {
            search_string,
            content_type: content_type ?? 'product',
            content_ids: (contents ?? []).map((content) => content.id),
        };
        facebookQueue('track', 'Search', object);
        facebookQueue('trackCustom', 'SearchWeb', object);
        return Promise.resolve();
    }
}
exports.SearchCommand = SearchCommand;
